import api from "./api";
import endpoints from "./endpoints";

export default {
  get: async function (catalogId, catalogMappingProjectId, language) {
    return api
      .get(endpoints.mapping.catalogMappings.get, {
        params: { catalogId, catalogMappingProjectId, language }
      })
      .then((x) => Promise.resolve(x.data));
  },
  create: async function (catalogMappingProjectId, attributeGroupId, languageCode, isReferential, isPublish) {
    return api
      .post(
        endpoints.mapping.catalogMappings.create,
        {},
        {
          params: {
            catalogMappingProjectId,
            attributeGroupId: attributeGroupId || null,
            languageCode,
            isReferential,
            isPublish
          }
        }
      )
      .then((x) => Promise.resolve(x.data));
  }
};
